// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyALPDZ5um7flrifa-h33WXQhBxKPdpVpIc",
    authDomain: "megastore-f7488.firebaseapp.com",
    projectId: "megastore-f7488",
    storageBucket: "megastore-f7488.firebasestorage.app",
    messagingSenderId: "93257152717",
    appId: "1:93257152717:web:9ab318c81c6db032f81184",
    measurementId: "G-Y2X9F1L8PY",
    vapidKey:
      'BBm_k5Jn34CI9Ix9U8EXJN30o6qdgQnXKUVNdHBxocb_FX2ZMmsb7eBBPTddjevYWX3Orr57UNmBU0uBvJPBsX8'
  },
  path: '/firebase-messaging-sw.js',
  scope: '/',
  // base_url: 'https://api-dev.mega-store.app/admin/api/v1/admin/',
  base_url: 'https://api-dev.mega-store.app/admin/api/v1/admin/',
  operational_url:
    'https://api-dev.mega-store.app/operational/api/v1/operational/',
  image_base_url:
    'https://api-dev.mega-store.app/common/api/v1/Upload/uploadFiles',
  multi_image_base_url:
    'https://api-dev.mega-store.app/common/api/v1/Upload/uploadMultiFiles',
  storageKey: 'megaStoreAccessToken',
  rememberMeKey: 'isRememberMeMegaStore',
  socketUrl: 'https://operational-api-dev.mega-store.app',
  adminOtpId: '_thserTz_12',
  googleKey: 'AIzaSyALPDZ5um7flrifa-h33WXQhBxKPdpVpIc'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
